import 'twin.macro';
import { Contact } from '@teetsh/app/src/containers/Director/Contact';
import { PageTrackerWrapper } from '@teetsh/app/src/queries/user/track';
import { Compte } from '@teetsh/app/src/containers/Director/Settings';
import { SidebarDirector } from '@teetsh/app/src/containers/Sidebar/SidebarDirector';
import { Header } from 'containers/Director/Layout/Header';
import React, { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ErrorPage } from '@teetsh/app/src/components/ErrorPage';
import { queryClient } from '@teetsh/app/src/queryClient';
import { loader as userLoader } from '@teetsh/app/src/queries/user/useUser';
import { useAuth } from '@teetsh/app/src/containers/App/context/AuthContext';

import App from '@teetsh/app/src/App';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import { DirectorAddLicencesPage } from 'containers/Director/SchoolSubscription/DirectorAddLicencesPage';
import DirectorSchoolSubscription from 'containers/Director/SchoolSubscription/Loadable';

function WithSidebar() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={'/login'} />;
  }

  if (!user.roles?.includes('director')) {
    return <Navigate to={'/'} />;
  }

  if (user.blockedAt) {
    return <Navigate to={'/blocked'} />;
  }

  return (
    <div tw="flex h-screen">
      <SidebarDirector />
      <div tw="relative flex-1 overflow-y-auto overflow-x-hidden h-full">
        <div tw="flex flex-col flex-1 h-full bg-neutral-supershy">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function PageWrapper({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  return (
    <>
      <Header />
      <PageTrackerWrapper title={title}>
        <TwoColumnsCardSidebar.Main tw="bg-neutral-supershy py-6" blank>
          {children}
        </TwoColumnsCardSidebar.Main>
      </PageTrackerWrapper>
    </>
  );
}

export const directorRoutes = [
  {
    path: '/direction',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        loader: userLoader(queryClient),
        children: [
          {
            element: <WithSidebar />,
            children: [
              {
                path: 'settings/account',
                element: (
                  <PageWrapper title="Director - compte">
                    <Compte />
                  </PageWrapper>
                ),
              },
              {
                path: 'school-subscription',
                children: [
                  {
                    path: 'licenses',
                    element: (
                      <PageWrapper title="Licenses page">
                        <DirectorSchoolSubscription />
                      </PageWrapper>
                    ),
                  },
                  {
                    path: 'invoices',
                    element: (
                      <PageWrapper title="Invoices page">
                        <DirectorSchoolSubscription />
                      </PageWrapper>
                    ),
                  },
                  {
                    path: 'addLicences',
                    element: (
                      <PageWrapper title="Ajouter des licences">
                        <DirectorAddLicencesPage />
                      </PageWrapper>
                    ),
                  },
                  {
                    index: true,
                    element: <Navigate to="licenses" />,
                  },
                ],
              },
              {
                path: 'contact',
                element: (
                  <PageWrapper title="Director - Contact">
                    <Contact />
                  </PageWrapper>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
